import React, { useState } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import BildHeader from "../../images/services/gewerbe-industrie/header.jpg"
import BildObenLinks from "../../images/services/gewerbe-industrie/obenlinks.jpg"
import BildObenRechts from "../../images/services/gewerbe-industrie/obenrechts.jpg"
import HeimberatungBild from "../../images/services/heimberatung/oben.jpg"
import SubNavigation from "../../components/SubNavServices"
import Termin from "../../components/Termin"

const GewerbeUndIndustrieberatung: React.FC = () => {
  const siteTitle = "Gewerbe und Heime – Dienstleistungen"
  const [isSubMenuOpen, setSubMenuOpen] = useState(false)

  return (
    <Layout title={siteTitle}>
      <SEO title={siteTitle} />
      <section className="wrapper">
        <div className="headerImage">
          <img src={BildHeader} />
        </div>
      </section>
      <Termin />
      <SubNavigation
        isSubMenuOpen={isSubMenuOpen}
        setSubMenuOpen={setSubMenuOpen}
        activeMenuText="Gewerbe und Heime"
      />
      <section className="wrapper greyColor content">
        <h1>Gewerbe und Industrie</h1>
        <h2 className="contentSubtitle">Beratung von SCHWARZ Optik</h2>
        <div className="contentColumns">
          <div className="contentColumn">
            <div className="imageCollection">
              <div className="imageColumn">
                <a
                  href="https://www.uvex-safety.com/de/produkte/schutzbrillen/"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <img src={BildObenLinks} />
                  <p className="imageCaption">
                    UVEX Schutzbrillen –<br />
                    Säurebeständig
                  </p>
                </a>
              </div>
              <div className="imageColumn">
                <a
                  href="https://www.uvex-safety.com/de/produkte/schutzbrillen/"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <img src={BildObenRechts} />
                  <p className="imageCaption">
                    UVEX Schutzbrillen –<br />
                    Kratzbeständig
                  </p>
                </a>
              </div>
            </div>
          </div>
          <div className="contentColumn">
            <h2>Sicher sehen – auch im Arbeitsalltag.</h2>
            <p>
              An vielen Arbeitsplätzen sind die Augen besonderen Belastungen ausgesetzt – sei es durch Staub, UV-Licht, scharfe Chemikalien oder Splittergefahr.
            </p>
            <p>
              SCHWARZ Optik analysiert konkrete Arbeitsplatzsituationen in Industrie, Labor oder Büro und erarbeitet individuelle Empfehlungen für zertifizierte Schutz- und Korrektionsschutzbrillen – abgestimmt auf Ihre Sehanforderungen und Sicherheitsvorgaben.
            </p>
            <h2>
              Unsere Leistungen für Gewerbe & Industrie:
            </h2>
            <ul>
              <li>Schutzbrillen mit Sehstärke (z. B. UVEX zertifiziert)</li>
              <li>Beratung & Anpassung vor Ort möglich</li>
              <li>Individuelle Lösungen für Bildschirmarbeit, Handwerk & Produktion</li>
              <li>Optional mit Augenvorsorge für Mitarbeitende</li>
            </ul>
            <a class="btn" href="https://www.click2date.eu/schwarz-optik.ch" target="_blank">Mehr Sicherheit, mehr Komfort – direkt von Ihrem Gesundheitsoptiker.</a>
          </div>
        </div>

        <h1>Heimberatung</h1>
        <h2 className="contentSubtitle">Beratung von SCHWARZ Optik</h2>
        <div className="contentColumns">
          <div className="contentColumn">
            <div className="imageCollection">
              <div className="imageRow">
                <img src={HeimberatungBild} />
              </div>
            </div>
            <p className="imageCaption">Passende Sehhilfen für jede Situation</p>
          </div>
          <div className="contentColumn">
            <h2>Heimberatung – weil gutes Sehen keine Frage des Ortes ist.</h2>
            <p>
              Nicht jeder kann in unser Geschäft kommen, aber wir kommen zu Ihnen.
SCHWARZ Optik bietet auf Wunsch <strong>individuelle Beratungen vor Ort</strong> an, sei es im Altersheim, im Spital oder bei Ihnen zu Hause.
            </p>
            <p>
              Ob Sehschwächen im Alter, vergrössernde Sehhilfen oder Nachkontrollen: Wir nehmen uns Zeit, prüfen die Bedürfnisse in Ruhe vor Ort und bringen passende Sehlösungen gleich mit.
            </p>
            <p>Für alle, die Wert auf Augenkomfort und Lebensqualität legen – auch im hohen Alter.</p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default GewerbeUndIndustrieberatung
